<template>
<svg viewBox="0 0 24 24" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-fill-send`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.3621 17.9368L11.116 19.4788C10.2428 20.559 9.80617 21.0997 9.42365 21.1585C9.09276 21.2091 8.75844 21.0905 8.53303 20.8431C8.2726 20.5568 8.27228 19.8619 8.27228 18.473V15.6341L12.3621 17.9368ZM20.0985 2.84407C20.3879 2.91202 20.6328 3.10543 20.7654 3.37141C20.9177 3.67731 20.8192 4.17287 20.6219 5.16243L17.9305 18.6644C17.7847 19.3954 17.7115 19.7607 17.5106 19.971C17.3347 20.155 17.0949 20.265 16.8406 20.2786C16.5504 20.2938 16.2251 20.111 15.576 19.7454L8.26935 15.6302L14.659 9.32454C14.7517 9.23304 14.7335 9.07811 14.6219 9.01106C14.5553 8.9714 14.4712 8.97334 14.4071 9.01692L6.30549 14.5247L3.53693 12.9652C2.65309 12.4674 2.21075 12.2184 2.07795 11.9027C1.96263 11.6278 1.97575 11.3152 2.11408 11.0511C2.27325 10.7478 2.7351 10.5367 3.65803 10.1156C3.65803 10.1156 6.16485 8.71529 10.8826 6.56282C15.1472 4.61716 18.3634 3.4043 18.3885 3.39485C19.3063 2.97608 19.7658 2.7664 20.0985 2.84407Z"/></svg>
</template>
<script>

export default {
  name: 'IconFillSend',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
